import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {take} from 'rxjs/operators';

import {StyleServiceService} from '../../_services/style-service.service';

/* Cartel de servicios post-shift (#9219): el reporte no verificó el empleo declarado y la
   línea degradó a DNI; se pregunta cuántos servicios presenta (0/1/2, espejo de la pregunta
   del camino empleo=No) y la respuesta fija la línea DNI real vía POST ac/cantServicios. */
@Component({
	selector: 'x-cartel-servicios-dialog',
	templateUrl: './cartel-servicios-dialog.component.html',
	styleUrls: ['./cartel-servicios-dialog.component.css'],
})
export class CartelServiciosDialogComponent implements OnInit {
	public useCredilowStyle: boolean;
	public cantServicios: number = undefined;

	constructor(
		public styleService: StyleServiceService,
		public dialogRef: MatDialogRef<CartelServiciosDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {dni: string; nombre: string; cantServicios?: number} = {dni: '', nombre: ''}
	) {}

	ngOnInit(): void {
		this.styleService.useCredilowStyle.pipe(take(1)).subscribe((useCredilowStyle) => {
			this.useCredilowStyle = useCredilowStyle;
		});
		// Reapertura por reintento: arranca con lo que el operador ya había elegido.
		this.cantServicios = this.data.cantServicios;
	}

	public seleccionarCantServicios(cantidad: number): void {
		this.cantServicios = cantidad;
	}

	public onCancelClick(): void {
		this.dialogRef.close(null);
	}

	public onContinueClick(): void {
		if (this.cantServicios === undefined) {
			return;
		}
		this.dialogRef.close(this.cantServicios);
	}
}
